<template>
  <div>
    <SettingsModal
      v-if="isSettingsModalVisible"
      @close="INTRO_SET_SETTINGS_MODAL_VISIBLE(false)"
    ></SettingsModal>
    <AddPage v-if="isAddPageVisible" @close="INTRO_SET_ADD_PAGE_VISIBLE(false)"></AddPage>
    <!-- <AccessManager v-if="isAccessManagerVisible" @close="INTRO_SET_ACCESS_MANAGER_VISIBLE(false)"></AccessManager> -->
    <CategoryManager v-if="isCategoriesManagerVisible"></CategoryManager>
    <CreateCategory v-if="isCategoriesCreateVisible"></CreateCategory>
    <PageLogs v-if="getPageLogsPage"></PageLogs>
  </div>
</template>

<script>
import AddPage from "./AddPage";
import AccessManager from "./AccessManager";
import SettingsModal from "./Settings";
import CategoryManager from "./CategoryManager";
import CreateCategory from "./CreateCategory";
import PageLogs from "./PageLogs";
import { mapGetters, mapMutations } from "vuex";
import {
  INTRO_SET_ACCESS_MANAGER_VISIBLE,
  INTRO_SET_ADD_PAGE_VISIBLE,
  INTRO_SET_SETTINGS_MODAL_VISIBLE
} from "../../store/actions/intro";

export default {
  name: "Modals",
  components: {
    AddPage,
    AccessManager,
    SettingsModal,
    CategoryManager,
    CreateCategory,
    PageLogs
  },
  computed: {
    ...mapGetters([
      "isAddPageVisible",
      "isAccessManagerVisible",
      "isSettingsModalVisible",
      "isCategoriesManagerVisible",
      "isCategoriesCreateVisible",
      "getPageLogsPage"
    ])
  },
  methods: {
    ...mapMutations([
      INTRO_SET_ACCESS_MANAGER_VISIBLE,
      INTRO_SET_ADD_PAGE_VISIBLE,
      INTRO_SET_SETTINGS_MODAL_VISIBLE
    ])
  }
};
</script>

<style>
</style>